<template>
  <div>
    <h2>施設の概要</h2>
    <div v-if="!$device.isMobile" class="fac-body-inner">
      <kcs-facility-image-slide
        :detail="detail"
        :detail-images="detailImages"
      />
      <div class="fac-body-outline">
        <kcs-facility-outline :detail="detail" />
      </div>
    </div>
    <kcs-facility-outline :detail="detail" v-if="$device.isMobile" />
  </div>
</template>

<script>
import KcsFacilityImageSlide from '@/components/molecules/kcs-facility-image-slide.vue'
import KcsFacilityOutline from '@/components/molecules/kcs-facility-outline.vue'
export default {
  components: {
    KcsFacilityImageSlide,
    KcsFacilityOutline
  },
  props: {
    detail: {
      type: Object,
      required: true
    },
    detailImages: {
      type: Array,
      required: true
    }
  }
}
</script>
